export default "/fcbcac1db17390110677298f9d30eeed9c121039/5640253749f57ce229257494a6b0bc26.svg";